/** userFolderSection + siteTextsMessages (split from slice A for max-lines). */
import { applyFolderAsOperationFr } from "@Front/Utils/applyFolderAsOperationFr";

export const COMMON_UI_I18N_PART2_SLICE_G = {
	userFolderSection: {
		toggleLabel: (clientDisplayName: string): string =>
			applyFolderAsOperationFr(`Afficher ou masquer le contenu du dossier pour ${clientDisplayName}`),
		toggleFallback: applyFolderAsOperationFr("Afficher ou masquer le contenu du dossier client"),
		toggleFallbackClient: "le client",
	},
	siteTextsMessages: {
		requiredFieldsError: "Merci de renseigner les champs obligatoires (clé, scope, locale, contenu).",
		createSuccess: "Texte créé avec succès.",
		createError: "Erreur lors de la création du texte.",
		publishSuccess: "Texte publié avec succès.",
		publishError: "Erreur lors de la publication du texte.",
		archiveConfirmTitle: "Archiver le texte ?",
		archiveConfirmMessagePrefix: "Archiver la version",
		archiveConfirmMessageMiddle: "du texte",
		archiveSuccess: "Texte archivé avec succès.",
		archiveError: "Erreur lors de l'archivage du texte.",
		loadError: "Erreur lors du chargement des textes du site.",
		loadingTexts: "Chargement des textes…",
		updateSuccess: "Texte sauvegardé avec succès.",
		updateError: "Erreur lors de la sauvegarde du texte.",
	},
} as const;
